var $ = require('jQuery');
var SimpleMDE = require('simplemde');
var sanitize = require('./utils.js').sanitize;
var beforeChange = require('./markdown-editor-before-change.js');

/**
 * Markdown editor.
 *
 * Usage:
 *   var markdownEditor = new MarkdownEditor();
 *   markdownEditor.setup(className);
 *
 */
module.exports = function() {

    // Configure the spell checker button
    var spellCheckerButton = function (textarea) {
        return {
            name: 'spell-checker',
            action: function toggleSpellChecker (editor) {
                var options = editor.options;

                options.spellChecker = !options.spellChecker;

                editor.toTextArea();
                editor = new SimpleMDE(options);
                editor.codemirror.on('beforeChange', beforeChange);
                setupHandlers(editor, textarea);

                // Attempt to trigger the spell checker immediately after the dictionary gets loaded
                setTimeout(() => {
                    editor.value(editor.value());
                }, 500);

                return editor;
            },
            className: 'fa fa-book',
            title: 'Spell checker',
        };
    };

    // Configure the guide button
    var guideButton = function () {
        return {
            name: 'guide',
            action: $('#markdown').find('#guide').html(),
            className: 'fa fa-question-circle',
            title: $('#markdown').find('#label').html(),
        };
    };

    // Configure toolbar
    var configureToolbar = function (textarea, toolbar = []) {
        var toolbarOptions = toolbar.length ? toolbar : [
            'bold', 'italic', 'heading', '|',
            'quote', 'unordered-list', 'ordered-list', '|',
            'link', '|',
            'preview', 'spell-checker', '|',
            'guide'
        ];

        if (textarea.data('language') !== 'en_GB') {
            toolbarOptions = toolbarOptions.filter(item => item !== 'spell-checker');
        }

        return toolbarOptions.map(item => {
            return item === 'spell-checker' ? spellCheckerButton(textarea) : item;
        }).map(item => {
            return item === 'guide' ? guideButton() : item;
        });
    };

    // Initialise a single editor
    var singleEditor = function (textarea, toolbar) {
        var options = {
            element: textarea.get(0),
            forceSync: true,
            spellChecker: false,
            status: false,
            toolbar: configureToolbar(textarea, toolbar),
            insertTexts: {
                link: ['[', '](https://)']
            }
        };

        var editor = new SimpleMDE(options);

        editor.options.previewRender = plainText =>
            sanitize(editor.markdown(plainText));

        editor.codemirror.on('beforeChange', beforeChange);

        setupHandlers(editor, textarea);

        return editor;
    };

    // Set up full editor
    var fullEditor = function (className) {
        $(className).each(function (index, textarea) {
            singleEditor($(textarea));
        });
    };

    // Set up single line editor
    var singleLineEditor = function (className) {
        var toolbar = ['bold', 'italic', '|', 'preview', 'spell-checker', '|', 'guide'];

        $(className).each(function (index, textarea) {
            singleEditor($(textarea), toolbar);
        });
    };

    var setupHandlers = function (editor, textarea) {
        bindEvents(editor, textarea);
        enableTabbing(editor, textarea);
        makeAccessible(editor);
        readOnly(editor, textarea);
    };

    var bindEvents = function (editor, textarea) {
        editor.codemirror.on('change', function (cm, e) {
            modifyLinks(editor, cm, e);
            $(textarea).trigger('change').trigger('keyup');
        });

        editor.codemirror.on('blur', function () {
            $(textarea).trigger('blur');
        });

        editor.codemirror.on('keydown', function () {
            $(textarea).trigger('keydown');
        });

        editor.codemirror.on('cursorActivity', function () {
            mdeFocus(editor, textarea)
        });

        editor.codemirror.on('focus', function () {
            mdeFocus(editor, textarea)
        });

        editor.codemirror.on('inputRead', function (cm, e) {
            modifyLinks(editor, cm, e);
        });
    };

    var enableTabbing = function (editor, textarea) {
        editor.codemirror.options.extraKeys['Tab'] = false;
        editor.codemirror.options.extraKeys['Shift-Tab'] = false;
    };

    var makeAccessible = function (editor) {
        if (editor.toolbarElements) {
            Object.keys(editor.toolbarElements).forEach(key => {
                var element = editor.toolbarElements[key];
                if (element.tagName === 'A') {
                    element.innerHTML = `<span class="sr-only">${element.title}</span>`;
                }
            });
        }
    };

    var readOnly = function (editor, textarea) {
        if ($(textarea).prop('disabled')) {
            $(textarea).siblings('.editor-toolbar').remove();
            if (!editor.isPreviewActive()) {
                editor.togglePreview();
            }
            $(textarea).siblings('.CodeMirror').find('.editor-preview').attr('disabled', true);
        }
    };

    var mdeFocus = function (editor, textarea) {
        var cursor = editor.codemirror.getCursor();
        $(textarea).trigger('mdeFocus', [editor.codemirror, cursor.line, cursor.ch]);
    };

    this.setup = function (className) {
        fullEditor(className);
    };

    this.singleLine = function (className) {
        singleLineEditor(className);
    };

    this.singleEditor = function (className, toolbar) {
        return singleEditor($(className), toolbar);
    };
    
    var modifyLinks = function ( editor, cm, event) {
        event.text.forEach(() => {
            editor.codemirror.doc.children.forEach(child => {
                let words = child.lines[event.from.line].text.split(' ');
                words.forEach(word => {
                    if (word.indexOf('http://') === 0 || word.indexOf('https://') === 0) {
                        if (word.indexOf('{') !== -1 || word.indexOf('}') !== -1) {
                            let newWord = word.replace(/\{/g, '%7B').replace(/\}/g, '%7D');
                            cm.getDoc().setValue(editor.value().replace(word, newWord));
                            cm.setCursor({line: event.to.line, ch: event.to.ch + newWord.length});
                        }
                    }
                });
            });
            
        });
    };
};
